import { getMomentTz } from "@dexteel/mesf-core";

const moment = getMomentTz();

export type OverlapCandidate = {
	EventId?: number | null;
	Start: Date | string;
	End: Date | string | null;
};

const overlaps = (
	start: number,
	end: number | null,
	candidate: OverlapCandidate,
) => {
	const cStart = moment(candidate.Start).valueOf();
	const cEnd = candidate.End ? moment(candidate.End).valueOf() : null;
	if (cEnd === null) return false;
	if (end === null) return start >= cStart && start < cEnd;
	return start < cEnd && end > cStart;
};

export const findNextFreeStart = ({
	start,
	end,
	events,
}: {
	start: Date;
	end: Date | null;
	events?: OverlapCandidate[];
}): Date | null => {
	const startValue = moment(start).valueOf();
	const endValue = end ? moment(end).valueOf() : null;

	const nextEnd = (events ?? [])
		.filter((event) => overlaps(startValue, endValue, event))
		.map((event) => moment(event.End as Date | string).valueOf())
		.filter((candidateEnd) => candidateEnd > startValue)
		.sort((left, right) => left - right)[0];

	return nextEnd === undefined ? null : new Date(nextEnd);
};
